import { useState, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { Camera } from 'three';

const useCameraState = (camera: Camera) => {
  const [cameraPosition, setCameraPosition] = useState(camera.position.clone());
  const [cameraRotation, setCameraRotation] = useState(camera.rotation.clone());

  useFrame(() => {
    const newPosition = camera.position.clone();
    const newRotation = camera.rotation.clone();

    if (!newPosition.equals(cameraPosition)) {
      setCameraPosition(newPosition);
    }
    if (!newRotation.equals(cameraRotation)) {
      setCameraRotation(newRotation);
    }
  });

  return { cameraPosition, cameraRotation };
};

export default useCameraState;
